module.exports = __webpack_public_path__ + "img/wechattitle.091591e2.png";